var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 0H1.625C0.73125 0 0 0.72 0 1.6V14.4C0 15.28 0.723125 16 1.61688 16H11.375C12.2688 16 13 15.28 13 14.4V4.8L8.125 0ZM9.75 8H3.25V9.6H9.75V8ZM9.75 11.2H3.25V12.8H9.75V11.2ZM1.625 14.4H11.375V5.6H7.3125V1.6H1.625V14.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoc);
export default __webpack_public_path__ + "static/media/icon-doc.b2bfbf3885c43c5c5e0f1b759a770f72.svg";
export { ForwardRef as ReactComponent };